module.exports = __webpack_public_path__ + "static/media/safetysystem-banner.36020404.png";